export function setupJobtextMap() {
    const mapContainer = document.querySelector('.jobtext-map');
    if (mapContainer) {
        const moreBtn = mapContainer.querySelector('.jobtext-map__more-btn');
        if (moreBtn) {
            const hiddenClass = 'jobtext-map__link--hidden';
            moreBtn.addEventListener('click', () => {
                for (const link of mapContainer.querySelectorAll('.' + hiddenClass)) {
                    link.classList.remove(hiddenClass);
                }
                moreBtn.remove();
            });
        }
    }
}
